// 引入axios以及element ui中的loading和message组件
import axios from "axios";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import store from "../store";
import { getToken } from "@/util/auth";
import { Loading, Message } from "element-ui";
import { getSign, findCharIndex } from "@/util/util";
import encryptor from "@/util/cypher";
import CryptoJS from "crypto-js";
const arr = [
  "/joins-wallet/v1/deposit",
  "/joins-wallet/v1/balance/downloadExcel",
  "/joins-wallet/v1/balance/downloadCheckingXls",
  "/joins-wallet/v1/balance/downloadExcelData",
  "/joins-sales-cloud/v1/delivery_order/downloadExcelMaterialRetrievalDetails",
  "/joins-sales-cloud/v1/delivery_order",
  "/joins-sales-cloud/v1/customs_declaration/downloadExcelWaterproofCustomsDeclaration",
  "/joins-sales-cloud/v1/customs_declaration/downloadExcelCustomsDeclaration",
  "/joins-sales-cloud/v1/customs_declaration/downloadExcelAreaConfigWaterproof",
  "/joins-sales-cloud/v1/customs_declaration",
  "/joins-sales-cloud/v1/customs_declaration/downloadExcelAreaConfig",
  "/joins-sales-cloud/v1/customs_declaration/downloadExcelWaterproof",
  "/joins-sales-cloud/v1/customs_declaration/downloadExcelWaterproofFinance",
  "/joins-sales-cloud/v1/customs_declaration/downloadExcelWaterproofDelivery",
  "/joins-sales-cloud/v1/customs_declaration/downloadExcelHangCeilingFinance",
  "/joins-sales-cloud/v1/customs_declaration/downloadExcelHangCeilingDelivery",
  "/joins-sales-cloud/v1/delivery_order/downloadExcelMaterialRetrievalDetailsHangCeiling",
  "/joins-sales-cloud/v1/pure_water_goods/engineering_goods",
  "/joins-sales-cloud/v1/preFilter/downloadExcelPureWaterGoods",
  "/joins-product/v1/order/refundDetail/downloadExcelRefundDetail"
];
let loading;
axios.defaults.timeout = 10000;
axios.defaults.headers.post["Content-Type"] = "application/json";
//跨域请求，允许保存cookie
axios.defaults.withCredentials = true;
NProgress.configure({
  showSpinner: false,
});
//HTTPrequest拦截
axios.interceptors.request.use(
  (config) => {
    //请求前到请求到数据这段时间用加载动画来代替，以服务方式调用
    if (!(config.url.indexOf("wx_native_pay_query") != -1)) {
      loading = Loading.service({
        fullscreen: true,
        text: "拼命加载中...",
        // target:'#main'
      });
    }
    const url = new URL(config.url);
    const path = url.pathname; //获取路径，url.pathname是获取路径的方法
    // 检查URL是否与数组arr中的元素完全匹配
    const isStringIncluded = arr.some((str) => str === path);
    if (isStringIncluded) {
      config.timeout = 100000; // 设置超时时间为100秒
    }
    if (path.indexOf("/joins-sales-cloud/v1/qr/downloadDoc/") != -1) {
      config.timeout = 100000; // 设置超时时间为100秒
    }
    // 签名加密
    let RSAModel = getSign(config.url, config.method);
    // 截取版本号，在第四和第五个斜杠中间截取
    let version = config.url.substring(
      findCharIndex(config.url, "/", 3) + 1,
      findCharIndex(config.url, "/", 4)
    );
    //处理上传文件，Content-Type类型值以及参数不json
    if (!config.ContentType) {
      config.ContentType = "application/json";
      config.data = JSON.stringify(config.data);
    }
    config.headers = {
      "Content-Type": config.ContentType,
      ACCEPT_SIGN: RSAModel.sign,
      ACCEPT_TIMESTAMP: RSAModel.timeStamp,
      ACCEPT_SECRETKEY: RSAModel.appId,
      ACCEPT_NONCE: RSAModel.nonce,
      version: version,
      ACCEPT_TOKEN: store.getters.token ? getToken() : "",
      'X-Debug-Target': '192.168.1.21',
    };
    return config;
  },
  (error) => {
    loading.close(); //关闭加载前，记得重新定义实例
    return Promise.reject(error);
  }
);
// 解密数据
function decryptData(encryptedData, sessionKey) {
  const sessionKeyBytes = CryptoJS.enc.Base64.parse(sessionKey);
  const encryptedDataBytes = CryptoJS.enc.Base64.parse(encryptedData);
  // 解密
  const decryptedData = CryptoJS.AES.decrypt({
    ciphertext: encryptedDataBytes
  },
    sessionKeyBytes, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  }
  );
  // 解密结果
  const decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
  return decryptedText;
}
//HTTPresponse拦截
axios.interceptors.response.use(
  (response) => {
    NProgress.done();
    let res = response.data;
    if (res instanceof Blob) {
      loading.close();
      return response;
    }
    let secretkey = response.headers.secretkey;
    if (secretkey) {
      secretkey = decodeURIComponent(encryptor.decrypt(secretkey));
      var decStr = decryptData(res, secretkey);
      decStr = decodeURIComponent(decStr);
      res = JSON.parse(decStr);
    }
    loading.close(); //关闭加载前，记得重新定义实例
    return res;
  },
  (error) => {
    switch (error.response && error.response.status) {
      case 402:
        this.$store.dispatch("LogOut").then(() => {
          this.$router.push({
            path: "/login",
          });
        });
        break;
      case 403:
        this.$store.dispatch("LogOut").then(() => {
          this.$router.push({
            path: "/login",
          });
        });
        break;
      case 500:
        Message.error("系统错误");
        break;
    }
    NProgress.done();
    loading.close(); //关闭加载前，记得重新定义实例
    return Promise.reject(error);
  }
);

export default axios;
